<div class="card-header" >
    <h4>Edit Product</h4>
</div>
<div class="card">
    <div class="row">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
                <a class="nav-link" [class.active]="activeTab === 'product'" >Product Details</a>
            </li>
            <li class="nav-item" role="presentation">
                <a class="nav-link" [class.active]="activeTab === 'commission'">Service Charges</a>
            </li>
        </ul>
    </div>
<div class="tab-content" id="myTabContent">
  <div id="product" class="tab-pane fade active show" [ngStyle]="{ 'display': activeTab === 'product'? 'block' : 'none'}">
    <form #productEdit="ngForm" (ngSubmit)="editProduct(productEdit.value)" [formGroup]="editProductForm">
    <div class="row">
        <div class="col-sm-6 mb-3 mb-sm-0">
            <div class="card border-0 shadow-none text-center">
              <div class="card-body ">
                  <img [src]="selectedFile"  width="150" height="150" class="rounded-circle mb-3" alt="category Image">
                  <br>
                  <div class="custom-file">
                    <div class="file btn btn-lg bg-primary" *ngIf="permissions.includes('Edit')">
                  Upload &nbsp;<i class="fa fa-upload"></i>
                  <input type="file" [ngClass]="{'is-invalid':submitted && editProductForm.controls.productImage.errors}" accept="image/*" (change)="setProductProfile($event)">
                  </div>
                  </div>
                  <div class="invalid-feedback mt-2" style="display: block;" id="fileNameDisplay"
                              *ngIf="submitted && editProductForm.controls.productImage.errors">
                              <div *ngIf="editProductForm.controls.productImage.errors?.required">
                                Icon is required.
                              </div>
                  </div>
                      
                  <a href="javascript:void(0)" *ngIf="editProductForm.get('productImage')?.valid && permissions.includes('Edit')" (click)="removeFile()"
                              class="position-absolute" style="top: 10px; right: 180px; color: #dc3545;">
                              <i class="fa fa-times-circle fa-lg"></i>
                  </a>
                  <p style="font-size: 13px; margin-top: 4px;">PNG/JPG with max size 50 KB allowed.</p>
              </div>
            </div>
        </div>
        <div class="col-sm-6">
          <div class="card border-0 shadow-none text-center">
            <div class="card-body">
                <br>
                <br>
                <p class="card-text">Here's how it will look on Mobile App </p>
                <br>
                <img src="assets\images\app-product.png" width="300" height="80" class=" mb-3" alt="...">
            </div>
          </div>
        </div>
    </div>
    <hr >
    <div class="row">
      <div class="col-lg-12">
        <div class="card border-0 shadow-none text-center">
          <div class="card-body">
            <div class="row d-flex">
                <div class="form-group col-md-3 ">
                    <label class="col-form-label" for="productName">Product Name <span aria-hidden="true"
                            class="symbol required" style="color:red;">*</span>
                    </label>
                    <input type="text" id="productName" autocomplete="off" [readOnly]="!permissions.includes('Edit')" class="form-control" required formControlName="productName" placeholder="Enter Product Name" [ngClass]="{'is-invalid':submitted && editProductForm.controls.productName.errors}" (keypress)="onProductNameKeyPress($event)" name="productName">
                    <div class="invalid-feedback">
                        Product Name is required
                      </div>
                </div>
                <div class="form-group col-md-3 ">
                    <label class="col-form-label" for="productDesc">Product Description <span aria-hidden="true"
                            class="symbol required" style="color:red;">*</span>
                    </label>
                    <input type="text" id="productDesc" autocomplete="off" class="form-control" [readOnly]="!permissions.includes('Edit')" required formControlName="productDesc" placeholder="Enter Product Description" [ngClass]="{'is-invalid':submitted && editProductForm.controls.productDesc.errors}" (keypress)="onProductDescKeyPress($event)" name="productDesc">
                    <div class="invalid-feedback">
                        Product Description is required
                      </div>
                </div>
                <div class="form-group col-md-3 ">
                    <label class="col-form-label" for="productCode">Product Code <span aria-hidden="true"
                            class="symbol required" style="color:red;">*</span>
                    </label>
                    <input type="text" id="productCode" autocomplete="off" class="form-control" readOnly required formControlName="productCode" placeholder="Enter Product Code" [ngClass]="{'is-invalid':submitted && editProductForm.controls.productCode.errors}"  name="productCode">
                    <div class="invalid-feedback">
                        Product Code is required
                      </div>
                </div>
                <div class="form-group col-md-3" style="margin-top: 25px;">
                       
                    <input class="form-check-input" style="margin-top: 10px;"  [attr.disabled]="permissions.includes('Edit') ? null : 'disabled'" type="checkbox" id="creditType" value="true" formControlName="creditType" name="creditType">
                    <label class=" col-form-label form-check-label" for="creditType" style="margin-left: 5px;"> Credit Type</label>
                    <div class="invalid-feedback" style="display: block;">  
                    </div>
                </div>
                
            </div>
            <br>
            <!-- <div class="row d-flex" *ngIf="!formDisabled">
               
                <div class="form-group col-md-3 ">
                    <label class="col-form-label" for="category">Category <span aria-hidden="true"
                            class="symbol required" style="color:red;">*</span>
                    </label>
                    <ng-select [items]="categoryDropdownList" placeholder="Select Category" bindLabel="name" bindValue="id"  (change)="categoryChange($event)" id="category" formControlName="category" required  [ngClass]="{'is-invalid':submitted && editProductForm.controls.category.errors}"  name="category">
                      </ng-select>
                    <div class="invalid-feedback">
                        <div >
                            Category is required
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-3 ">
                    <label class="col-form-label" for="subCategory">SubCategory <span aria-hidden="true"
                            class="symbol required" style="color:red;">*</span>
                    </label>
                    <ng-select [items]="subCategoryDropdownList" bindLabel="name" bindValue="id" id="subCategory" (change)="subCategoryChange($event)" formControlName="subCategory" placeholder="Select Subcategory" required  [ngClass]="{'is-invalid':submitted && editProductForm.controls.subCategory.errors}"  name="subCategory">
                    </ng-select>
                    <div class="invalid-feedback">
                        <div >
                            Subcategory is required
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-3 ">
                    <label class="col-form-label" for="status">Status <span aria-hidden="true"
                            class="symbol required" style="color:red;">*</span>
                    </label>
                    <ng-select id="status" placeholder="Select Status" (change)="statusChange($event)" formControlName="status" required [ngClass]="{'is-invalid':submitted && editProductForm.controls.status.errors}"  name="status">
                        <ng-option value="ACTIVE">Active</ng-option>
                        <ng-option value="INACTIVE">Inactive</ng-option>
                      </ng-select>
                    <div class="invalid-feedback">
                        <div >
                            Status is required
                        </div>
                    </div>
                </div>

            </div> -->
            <div class="row d-flex">
                <div class="form-group col-md-3 ">
                    <label class="col-form-label">Category <span aria-hidden="true"
                        class="symbol required" style="color:red;">*</span></label>
                    <input type="text" id="category" readonly value="{{categoryName}}" class="form-control">
                </div>
                <div class="form-group col-md-3 ">
                    <label class="col-form-label">Sub Category <span aria-hidden="true"
                        class="symbol required" style="color:red;">*</span></label> 
                    <input type="text"  id="subCategory" readonly value="{{subCategoryName}}" class="form-control">
                </div>
                <div class="form-group col-md-3 " *ngIf="permissions.includes('Edit')">
                    <label class="col-form-label">Status <span aria-hidden="true"
                        class="symbol required" style="color:red;">*</span></label>
                    <input type="text" id="productName" readonly value="{{this.editProductForm.value.status | titlecase}}" class="form-control">
                </div>
                <div class="form-group col-md-3 "  *ngIf="permissions.includes('Approve')">
                    <label class="col-form-label" for="status">Status <span aria-hidden="true"
                            class="symbol required" style="color:red;">*</span>
                    </label>
                    <ng-select id="status" placeholder="Select Status" (change)="statusChange($event)" formControlName="status" required [ngClass]="{'is-invalid':submitted && editProductForm.controls.status.errors}"  name="status">
                        <ng-option value="ACTIVE">Active</ng-option>
                        <ng-option value="INACTIVE">Inactive</ng-option>
                      </ng-select>
                    <div class="invalid-feedback">
                        <div >
                            Status is required
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-3 "  style="margin-top: 25px;">
                    <button type="button" class="btn btn-primary" (click)="statusChangeApi()" *ngIf="permissions.includes('Approve')">Change Status</button>
                </div>
            </div>
            <div class="row d-flex" *ngIf="permissions.includes('Edit')">
                <div class="form-group col-md-3 ">
                    <label class="col-form-label" for="countryProduct">Country <span aria-hidden="true"
                            class="symbol required" style="color:red;">*</span>
                    </label>
                    <ng-select id="countryProduct" [items]="countryDropDown" bindLabel="name" bindValue="id" placeholder="Select Country"  formControlName="countryProduct" (change)="countryProductSelect($event)" name="countryProduct">
                    </ng-select>
                    <div class="invalid-feedback">
                        <div >
                            Country is required
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <hr>
            <div class="row d-flex">
                <div class="form-group col-md-12 ">
                    <div class="row mb-0" style="min-height: 270px">
                        <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                          <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReadyMaxList($event)" (rowClicked)="onRowClicked($event)" 
                            [columnDefs]="tableSelectedColumn1" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
                             [rowData]="maxAmountData" [rowModelType]="" [rowSelection]="'single'"
                            [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                          </ag-grid-angular>
                        </div>
                      </div>
                </div>
            </div>
           
            <div class="row d-flex">
                <div class="form-group col-md-12 text-right">
                    <button type="submit" class="btn btn-primary" *ngIf="permissions.includes('Edit')">Save & Next</button>
                    <button type="button" class="btn btn-primary" id="cancelButton" (click)="nextButton()" *ngIf="permissions.includes('Approve') || permissions.includes('View')">Next</button>
                    <button type="button" class="btn btn-secondary" id="cancelButton" (click)="cancelButton()">Cancel</button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>  
    </form> 
    </div>
    <div id="commission" class="tab-pane fade active show" [ngStyle]="{ 'display': activeTab === 'commission'? 'block' : 'none'}">
        <form #commissionEdit="ngForm" (ngSubmit)="editCommission(commissionEdit.value)" [formGroup]="editCommissionForm">
        <div class="row">
            <div class="col-lg-12">
              <div class="card border-0 shadow-none text-center">
                <div class="card-body">
                  <div class="row d-flex">
                    <div class="form-group col-md-2 ">
                        <label class="col-form-label">Product Name</label>
                        <input type="text" id="productName" readonly value="{{this.editProductForm.value.productName}}" class="form-control">
                    </div>
                    <div class="form-group col-md-2 ">
                        <label class="col-form-label">Category</label>
                        <input type="text" id="category" readonly value="{{categoryName}}" class="form-control">
                    </div>
                    <div class="form-group col-md-2 ">
                        <label class="col-form-label">Sub Category</label> 
                        <input type="text"  id="subCategory" readonly value="{{subCategoryName}}" class="form-control">
                    </div>
                    <div class="form-group col-md-3 " >
                        <label class="col-form-label" for="country">Country <span aria-hidden="true"
                                class="symbol required" style="color:red;">*</span>
                        </label> 
                        <ng-select  id="country" formControlName="country" placeholder="Select Country" (change)="countrySelect($event)" required  [ngClass]="{'is-invalid':submittedCommission && editCommissionForm.controls.country.errors}" name="country">
                            <ng-option *ngFor="let country of countryAmountList; let i = index" [value]="country.country">{{country.countryName | titlecase}}</ng-option>
                          </ng-select>
                        <div class="invalid-feedback">
                            <div >
                                Country is required
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-md-3 " *ngIf="maximumAmount">
                        <label class="col-form-label" for="maxAmount">Maximum Amount <span aria-hidden="true"
                                class="symbol required" style="color:red;">*</span>
                        </label>
                        <input type="number" id="maxAmount" class="form-control" readOnly formControlName="maxAmount" [ngClass]="{'is-invalid':submittedCommission && editCommissionForm.controls.maxAmount.errors}" name="maxAmount">
                        
                    </div>
                </div>
                <div class="row d-flex" *ngIf="(permissions.includes('Edit') && showAddSlabButton)">
                    <div class="text-right">
                        <button type="button" class="btn btn-primary" *ngIf="savedSlabDataVisible" (click)="cloneSavedData()">Copy</button>
                        <button type="button" class="btn btn-primary"  (click)="addSlabCheck()">New</button>
                    </div>
                </div>  
                <div class="row d-flex" *ngIf="permissions.includes('Approve')">
                    <div class="text-right">
                        <button type="button" class="btn btn-primary"  (click)="reviewSlab($event)">Review</button>
                    </div>
                </div>
                <div class="row d-flex">
                    <div class="form-group col-md-12 "  *ngIf="savedSlabDataVisible">
                        <div class="row mb-0" style="min-height: 270px">
                            <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                              <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)" 
                                [columnDefs]="saveDataTable" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
                                 [rowData]="savedData" [rowModelType]="" [rowSelection]="'single'"
                                [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                              </ag-grid-angular>
                            </div>
                          </div>
                    </div>
                </div>
                <div class="row d-flex" *ngIf="showSlabInformation">
                    <h4 style="color: red;">Rates are not yet configured for this country</h4>
                </div>
                <br>
                <div class="row d-flex" *ngIf="selectedClone">
                    <br>
                    <div class="form-group col-md-12 " >
                        <div class="d-flex mb-2 justify-content-between">
                            <h5 class="text-left">Clone</h5>
                            <div class="text-right">
                                <!-- <button type="button" class="btn btn-primary" *ngIf="cloneSlab" (click)="addSlab()">Add Slab</button> -->
                                <button type="button" class="btn btn-primary"  (click)="selectSpecificAmount()">Add Specific Amount</button>
                                <button type="button" class="btn btn-primary" (click)="clearTable('CLONE')">Clear</button>
                            </div>
                        </div>
                        <div class="row mb-0" style="min-height: 270px">
                            <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                              <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)" 
                                [columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
                                 [rowData]="slabData" [rowModelType]="" [rowSelection]="'single'" (stopEditingWhenGridLosesFocus)="true"  (cellValueChanged)="onCellValueChanged($event)"
                                [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                              </ag-grid-angular>
                              <!-- (cellEditingStopped)="onCellEditingStopped($event)" -->
                            </div>
                          </div>
                    </div>
                </div>
                
                <div class="row d-flex">
                    <div class="form-group col-md-3 " *ngIf="addSlabPermission">
                        <label class="col-form-label" for="type">Type<span aria-hidden="true"
                                class="symbol required" style="color:red;">*</span>
                        </label>
                        <ng-select id="type"  formControlName="type" (change)="typeSelect()" required [ngClass]="{'is-invalid':submittedCommission && editCommissionForm.controls.type.errors}" name="type">
                            <ng-option diabled selected value="">Select Type</ng-option>
                            <ng-option value="DIRECT">Direct</ng-option>
                            <ng-option value="SLAB">Slab</ng-option>
                          </ng-select>
                        <div class="invalid-feedback">
                            <div >
                                Type is required
                            </div>
                        </div>
                    </div>
                    <div class="row d-flex">
                        <div class="form-group col-md-12 "  *ngIf="selectedDirect">
                            <div class="d-flex mb-2 justify-content-between">
                                <h5 class="text-left">Direct</h5>
                                <div class="text-right">
                                    <button type="button" class="btn btn-primary" *ngIf="showAddDirectSlabButton" (click)="addDirectSlab()">Add Direct</button>
                                    <button type="button" class="btn btn-primary"  (click)="selectSpecificAmount()">Add Specific Amount</button>
                                    <button type="button" class="btn btn-primary" (click)="clearTable('DIRECT')">Clear</button>
                                </div>
                            </div>
                            <div class="row mb-0" style="min-height: 270px">
                                <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                                  <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)" 
                                    [columnDefs]="tableSelectedColumnDirect" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true 
                                     [rowData]="directData" [rowModelType]="" [rowSelection]="'single'"  (cellValueChanged)="onCellValueChanged($event)"
                                    [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                                  </ag-grid-angular>
                                </div>
                              </div>
                        </div>
                    </div>
                    <div class="row d-flex">
                        <div class="form-group col-md-12 " *ngIf="selectedSlab">
                            <div class="d-flex mb-2 justify-content-between">
                                <h5 class="text-left">Slab</h5>
                                <div class="text-right">
                                    <button type="button" class="btn btn-primary" (click)="addSlab()">Add Slab</button>
                                    <button type="button" class="btn btn-primary"  (click)="selectSpecificAmount()">Add Specific Amount</button>
                                    <button type="button" class="btn btn-primary" (click)="clearTable('SLAB')">Clear</button>
                                </div>
                            </div>
                            <div class="row mb-0" style="min-height: 270px">
                                <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                                  <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)" 
                                    [columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
                                     [rowData]="slabData" [rowModelType]="" [rowSelection]="'single'" (stopEditingWhenGridLosesFocus)="true"  (cellValueChanged)="onCellValueChanged($event)"
                                    [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                                  </ag-grid-angular>
                                  <!-- (cellEditingStopped)="onCellEditingStopped($event)" -->
                                </div>
                              </div>
                        </div>
                    </div>
                    
                </div>
                  
                  
                  <div class="row d-flex" >
                      <div class="form-group col-md-12 text-right">
                          <button type="button" class="btn btn-secondary" id="cancelButton" (click)="switchTab('product')">Back</button>
                          <button type="submit" class="btn btn-primary" *ngIf="saveButtonVisible">Save</button>
                          <button type="button" class="btn btn-danger" id="cancelButton" (click)="cancelButton()">Cancel</button>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
    </div>
    </div>
  
</div>
<div class="mt-4">
    <p style="font-weight: 300;">Note: No charges will be levied in case exchange rate is not configured for the Product.</p>
</div>

<app-modal #openReviewSlab [modalConfig]="modalProductReview" style="width: 1200px;">
   
<h4 class="text-center">Review Changes</h4>
<div *ngIf="showOldSlab">
<br>
<br>
<h5>Old Slab</h5>
<div class="row d-flex">
    <div class="form-group col-md-12 " >
        <div class="row mb-0" style="min-height: 270px">
            <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
              <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)" 
                [columnDefs]="saveDataTable" [defaultColDef]="reviewSlabCol" [enableCellTextSelection]=true
                 [rowData]="oldSlab" [rowModelType]="" [rowSelection]="'single'"
                [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
              </ag-grid-angular>
            </div>
          </div>
    </div>
</div>
</div>
<div *ngIf="showNewSlab">
<br>
<br>
<h5>New Slab</h5>
<div class="row d-flex">
    <div class="form-group col-md-12 " >
        <div class="row mb-0" style="min-height: 270px">
            <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
              <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)" 
                [columnDefs]="saveDataTable" [defaultColDef]="reviewSlabCol" [enableCellTextSelection]=true
                 [rowData]="newSlab" [rowModelType]="" [rowSelection]="'single'"
                [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
              </ag-grid-angular>
            </div>
          </div>
    </div>
</div>
</div>

<div class="row d-flex">
    <div class="form-group col-md-12">
        <div class="text-center">
        <input type="text" autocomplete="off"  id="inputBorder" placeholder="Enter the Remarks"  [(ngModel)]="slabRemarks" >
        </div>
    </div>
</div>


<div class="row d-flex">
    <div class="form-group col-md-12 text-center">
        <button type="button" class="btn btn-primary" (click)="approveSlab()">Approve</button>
        <button type="button" class="btn btn-secondary" id="rejectButton"(click)="rejectSlab()" >Reject</button>
    </div>
</div>

</app-modal> 


<app-modal #reviewCountryMapping [modalConfig]="reviewCountry" >
   
    <h4 class="text-center">Country review for Product</h4>
    <br>
    <div class="row d-flex">
        <div class="form-group col-md-12">
            <div class="text-center">
            <input type="text" autocomplete="off"  id="inputBorder" placeholder="Enter the Remarks"  [(ngModel)]="countryRemark" >
            </div>
        </div>
    </div>
    <div class="row d-flex">
        <div class="form-group col-md-12 text-center">
            <button type="button" class="btn btn-primary" (click)="reviewCountryStatus('ACTIVE')">Approve</button>
            <button type="button" class="btn btn-secondary" id="rejectButton" (click)="reviewCountryStatus('REJECTED')" >Reject</button>
        </div>
    </div>
    
</app-modal>